import { requireStates, ConnectComponent2 } from "util";
import View from "./company-view.view";
import Presenter from "./company-view.presenter";

const initialStates = [
  {
    name: "app.registration.company.view",
    url: "/:companyUuid",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/index.js